import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const configurationClient = axios.create({
  baseURL: process.env.VUE_APP_PATIENT_URL,
  withCredentials: true,
});

configurationClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(configurationClient);

export default configurationClient;